export const STEP = 'STEP';
export const PLAYHEAD_DIRECTION_BUTTON = "PLAYHEAD_DIRECTION_BUTTON";
export const TRACK = 'TRACK';
export const MODULATOR_CONTROL = 'MODULATOR_CONTROL';
export const TRACK_THUMBNAIL = 'TRACK_THUMBNAIL';
export const FILTER_BY_DAY_TAG = 'FILTER_BY_DAY_TAG';
export const FILTER_BY_DAY= 'FILTER_BY_DAY';
export const FILTER_BY_TAG = 'FILTER_BY_TAG';
export const TRACK_EFFECTS_BUTTON = 'TRACK_EFFECTS_BUTTON';
export const TRACK_PIANO_ROLL_BUTTON = 'TRACK_PIANO_ROLL_BUTTON';
export const TRACK_PIANO_ROLL_BACK_BUTTON = 'TRACK_PIANO_ROLL_BACK_BUTTON';
export const TRACK_ADD_STEPS_BUTTON = 'TRACK_ADD_STEPS_BUTTON';
export const TRACK_REMOVE_STEPS_BUTTON = 'TRACK_REMOVE_STEPS_BUTTON';
export const TRACK_MUTE_BUTTON = 'TRACK_MUTE_BUTTON';
export const TRACK_SOLO_BUTTON = 'TRACK_SOLO_BUTTON';
export const TRACK_RECORD_ARM_BUTTON = 'TRACK_RECORD_ARM_BUTTON';
export const TRACK_MIDI_DROPDOWN = 'TRACK_MIDI_DROPDOWN';
export const ADD_EFFECTS_BUTTON = 'ADD_EFFECTS_BUTTON';
export const TRACK_SEND_A_SLIDER = 'TRACK_SEND_A_SLIDER';
export const TRACK_SEND_B_SLIDER = 'TRACK_SEND_B_SLIDER';
export const TRACK_LOCK_BUTTON = 'TRACK_LOCK_BUTTON';
export const LFOS_BUTTON = 'LFOS_BUTTON';
export const ENVELOPES_BUTTON = 'ENVELOPES_BUTTON';
export const LFO_TOGGLE_BUTTON= 'LFO_TOGGLE_BUTTON';
export const ENVELOPE_TOGGLE_BUTTON= 'ENVELOPE_TOGGLE_BUTTON';
export const EFFECT_PARAMETER = 'EFFECT_PARAMETER';
export const PARAMETER_VALUE = 'PARAMETER_VALUE';
export const EFFECT_TOGGLE_BUTTON = 'EFFECT_TOGGLE_BUTTON';
export const EFFECT_PRESETS_BUTTON = 'EFFECT_PRESETS_BUTTON';
export const EFFECT_RETURN_PRESETS_BUTTON = 'EFFECT_RETURN_PRESETS_BUTTON';
export const EFFECT_COLLAPSE_BUTTON = 'EFFECT_COLLAPSE_BUTTON';
export const EFFECT_DELETE_BUTTON = 'EFFECT_DELETE_BUTTON';

export const ADD_SOUND_BUTTON = 'ADD_SOUND_BUTTON';
export const PARAMETER_MODS_BUTTON = 'PARAMETER_MODS_BUTTON';
export const CURRENT_PATTERN_BUTTON = 'CURRENT_PATTERN_BUTTON';
export const PATTERN_BUTTON = 'PATTERN_BUTTON';
export const NEW_PATTERN_BUTTON = 'NEW_PATTERN_BUTTON';
export const DELETE_PATTERN_BUTTON = 'DELETE_PATTERN_BUTTON';
export const CURRENT_SUB_SEQUENCE_BUTTON = 'CURRENT_SUB_SEQUENCE_BUTTON';
export const NEW_SUB_SEQUENCE_BUTTON = 'NEW_SUB_SEQUENCE_BUTTON';
export const DELETE_SUB_SEQUENCE_BUTTON = 'DELETE_SUB_SEQUENCE_BUTTON';
export const RESOLUTION_DROPDOWN = 'RESOLUTION_DROPDOWN';

export const PLAY_BUTTON = 'PLAY_BUTTON';
export const RECORD_BUTTON = 'RECORD_BUTTON';
export const ROLL_BUTTON = 'ROLL_BUTTON';
export const QUANTIZE_BUTTON = 'QUANTIZE_BUTTON';

export const AND_TAG_BUTTON = 'AND_TAG_BUTTON';
export const OR_TAG_BUTTON = 'OR_TAG_BUTTON';
export const SELECTOR_TAG_BUTTON = 'SELECTOR_TAG_BUTTON';
export const SELECTOR_CATEGORY_BUTTON = 'SELECTOR_CATEGORY_BUTTON';

// detail page
export const TRACK_PARAMETERS = 'TRACK_PARAMETERS';
export const TRACK_WAVEFORM = 'TRACK_WAVEFORM';
export const SELECTOR_WAVEFORM = 'SELECTOR_WAVEFORM';
export const DETAIL_VIEW_HAS_SELECTED_SLICE = 'DETAIL_VIEW_HAS_SELECTED_SLICE';
export const GRAPHICAL_KEYBOARD = 'GRAPHICAL_KEYBOARD';


export const ARRANGEMENT_LOOP_BUTTON = 'ARRANGEMENT_LOOP_BUTTON';

// envelopes and lfos
export const ENVELOPE_TRACK_DROPDOWN = 'ENVELOPE_TRACK_DROPDOWN';
export const LFO_MIN_SLIDER = 'LFO_MIN_SLIDER';
export const LFO_MAX_SLIDER = 'LFO_MAX_SLIDER';

// Parameterizer effect
export const PARAMETERIZER_FACTOR = 'PARAMETERIZER_FACTOR';
export const PARAMETERIZER_OFFSET= 'PARAMETERIZER_OFFSET';
export const PROBABILITY = 'PROBABILITY';
export const PARAMETERIZER_DROPDOWN = 'PARAMETERIZER_DROPDOWN';

// piano roll 
export const TRANSCRIBE = 'TRANSCRIBE';
export const RESAMPLE = 'RESAMPLE';

// mix record buttons
export const PLAY_MIX_BUTTON = 'PLAY_MIX_BUTTON';
export const RECORD_MIX_BUTTON = 'RECORD_MIX_BUTTON';
export const AUTOMATION_BUTTON= 'AUTOMATION_BUTTON';

// dropdown in selector sound
export const CONVOLVER_BUTTON= 'CONVOLVER_BUTTON';
export const AUDITION_BUTTON= 'AUDITION_BUTTON';
export const LAYER_BUTTON= 'LAYER_BUTTON';

export const BROWSE_SOUNDS = 'BROWSE_SOUNDS';

// instruments menu
export const ADD_SYNTH_BUTTON= 'ADD_SYNTH_BUTTON';
export const ADD_MULTI_SYNTH_BUTTON= 'ADD_MULTI_SYNTH_BUTTON';
export const ADD_FM_SYNTH_BUTTON= 'ADD_FM_SYNTH_BUTTON';
export const ADD_EXTERNAL_INSTRUMENT_BUTTON= 'ADD_EXTERNAL_INSTRUMENT_BUTTON';

// presets
export const ADD_PRESET_BUTTON= 'ADD_PRESET_BUTTON';

export const LFO_COMPONENT = 'LFO_COMPONENT';
export const ENVELOPE_COMPONENT = 'ENVELOPE_COMPONENT';
export const ENVELOPE_TOGGLE = 'ENVELOPE_TOGGLE';

export const ADD_ALL_SOUNDS_BUTTON = 'ADD_ALL_SOUNDS_BUTTON';
export const ADD_SOUNDS_BUTTON = 'ADD_SOUNDS_BUTTON';
export const ADD_INSTRUMENTS_BUTTON = 'ADD_INSTRUMENTS_BUTTON';
export const ADD_PRESETS_BUTTON = 'ADD_PRESETS_BUTTON';
export const ADD_SEQUENCES_BUTTON = 'ADD_SEQUENCES_BUTTON';
export const VIEW_DROPDOWN = 'VIEW_DROPDOWN';
export const BPM_SLIDER= 'BPM_SLIDER';
export const SWING_SLIDER= 'SWING_SLIDER';
export const BPM_LOCK = 'BPM_LOCK';
export const PUBLIC_SAVE = 'PUBLIC_SAVE';
export const PRIVATE_SAVE = 'PRIVATE_SAVE';
export const PRESET_FOLDERS = 'PRESET_FOLDERS';
export const GUILDS_SELECTOR = 'GUILDS_SELECTOR';

export const FREEZE_BUTTON = 'FREEZE_BUTTON';
export const UNFREEZE_BUTTON = 'UNFREEZE_BUTTON';
export const TRACK_LENGTH_BUTTON = 'TRACK_LENGTH_BUTTON';
export const TRACK_DELETE_BUTTON = 'TRACK_DELETE_BUTTON';
export const WARP_BUTTON = 'WARP_BUTTON';

export const QUICK_ADD_BUTTON = 'QUICK_ADD_BUTTON';
export const QUICK_ADD_INSTRUMENT_BUTTON = 'QUICK_ADD_INSTRUMENT_BUTTON';
export const SIDEBAR_SEARCH = 'SIDEBAR_SEARCH';
export const SOUNDS_SEARCH = 'SOUNDS_SEARCH';
export const METRONOME_BUTTON= 'METRONOME_BUTTON';

// synth explorer
export const CHOOSE_INSTRUMENT_PRESET = 'CHOOSE_INSTRUMENT_PRESET';
export const FILTER_INSTRUMENT_TAG = 'FILTER_INSTRUMENT_TAG';
export const INSTRUMENT_FX_LOAD = 'INSTRUMENT_FX_LOAD';
export const INSTRUMENT_MODS_LOAD = 'INSTRUMENT_MODS_LOAD';

export const OPERATOR_HARMONICITY_MODULATION = 'OPERATOR_HARMONICITY_MODULATION';
export const SYNTH_ENVELOPE = 'SYNTH_ENVELOPE';
export const SELECTOR_GRID_VIEW= 'SELECTOR_GRID_VIEW';
export const SELECTOR_LIST_VIEW= 'SELECTOR_LIST_VIEW';

export const NEW_RACK_CONFIGURATION = 'NEW_RACK_CONFIGURATION';
export const RACK_CONFIGURATION_OPTION = 'RACK_CONFIGURATION_OPTION';
export const RACK_NODE_OUTPUT = 'RACK_NODE_OUTPUT';
export const RACK_NODE_INPUT= 'RACK_NODE_INPUT';
export const RACK_MODULATOR_OUTPUT = 'RACK_MODULATOR_OUTPUT';

export const PADS_DELETE_BUTTON = 'PADS_DELETE_BUTTON';
export const PADS_SLOT_EMPTY = 'PADS_SLOT_EMPTY';
export const PADS_SLOT= 'PADS_SLOT';
export const PADS_MUTES_BUTTON = 'PADS_MUTES_BUTTON';
export const PADS_WAVEFORM_BUTTON = 'PADS_WAVEFORM_BUTTON';
export const PADS_EXPAND_BUTTON = 'PADS_EXPAND_BUTTON';
export const PADS_LENGTH_BUTTON = 'PADS_LENGTH_BUTTON';

export const ELEMENT_TO_TEXT = {
    STEP: ['Click to toggle on/off. ',
           '⌘+click or Alt+click to view step\'s parameters. Drag the right edge to change it\'s duration.',
           'Type shift to hide the parameters.'
          ],
    TRACK: 'An audio track. Click to select the track. And press a key to map the key to the selected track.',
    TRACK_THUMBNAIL: 'Click to view details for this track.',
    TRACK_EFFECTS_BUTTON: 'Click to show the effects for this track.',
    TRACK_PIANO_ROLL_BUTTON: 'Click to show a piano roll at the bottom.',
    TRACK_ADD_STEPS_BUTTON: 'Click to double the length of steps in this track.',
    TRACK_REMOVE_STEPS_BUTTON: 'Click to half the length of steps in this track.',
    TRACK_MUTE_BUTTON: 'Click to mute/unmute the track.',
    TRACK_SOLO_BUTTON: 'Click to solo/un-solo the track. When soloed, you will only hear this track\'s output',
    TRACK_RECORD_ARM_BUTTON: 'Click to arm this track. When armed (red), you can play this track like a keyboard, by using your computer keyboard or a midi controller.',
    TRACK_MIDI_DROPDOWN: 'Specify what inputs can control this track when the record arm button is enabled. By default, the computer keyboard and MIDI controllers are enabled.',
    ADD_EFFECTS_BUTTON: 'Click to add effects to this track.',
    TRACK_SEND_A_SLIDER: 'Controls the level of output from this track that goes to \"Send A\". \"Send A\" by default is a reverb.',
    TRACK_SEND_B_SLIDER: 'Controls the level of output from this track that goes to \"Send B\". \"Send B\" by default is a delay.',
    TRACK_LOCK_BUTTON: 'Click to lock/unlock this track\'s parameters to this pattern. A track can be locked with respect to specific pattern. Any parameter changes made to a locked track are specific to that pattern.',
    LFOS_BUTTON: 'Click to edit the project-wide LFOs',
    ENVELOPES_BUTTON: 'Click to edit the project-wide envelopes',
    LFO_TOGGLE_BUTTON: 'Click to control this parameter with one of the project-wide LFOs',
    ENVELOPE_TOGGLE_BUTTON: 'Click to control this parameter with one of the project-wide envelopes',
    EFFECT_PARAMETER: 'Click the parameter name to display the LFOs/Envelopes that can control this parameter.',
    EFFECT_TOGGLE_BUTTON: 'Click the toggle the effect on/off.',
    EFFECT_COLLAPSE_BUTTON: 'Click to collapse/uncollapse the effect.',
    EFFECT_DELETE_BUTTON: 'Click to delete this effect.',
    EFFECT_PRESETS_BUTTON: 'Click to view presets for this effect.',
    EFFECT_RETURN_PRESETS_BUTTON: 'Click to return to the effect view.',
    ADD_SOUND_BUTTON: 'Click to view sound. Click again, or drag, to add to the project.',
    PARAMETER_MODS_BUTTON: 'Click to fine-tune the LFO/Envelope modulations (if any) for this effect.',
    CURRENT_SUB_SEQUENCE_BUTTON: 'Click to go to this sub-sequence. ',
    NEW_SUB_SEQUENCE_BUTTON: 'Click to create a new sub-sequence.',
    DELETE_SUB_SEQUENCE_BUTTON: 'Click to delete the current sub-sequence.',
    CURRENT_PATTERN_BUTTON: 'The current pattern of this project.',
    PATTERN_BUTTON: 'Click to switch to another pattern',
    NEW_PATTERN_BUTTON: 'Click to create a new pattern, copied from the current pattern.',
    DELETE_PATTERN_BUTTON: 'Click to delete the current pattern.',
    RESOLUTION_DROPDOWN: 'Specify the step resolution of the step sequencer. For example, you can view the steps in triplets.',
    PLAY_BUTTON: 'Click to play the project in pattern mode.',
    RECORD_BUTTON: 'Click to toggle recording. When recording, anything triggered via the computer-keyboard/midi controller will be recorded into the pattern.',
    ROLL_BUTTON: 'Click to enable \"roll\". When enabled, you can trigger tracks in time with the selected resolution of the project.',
    QUANTIZE_BUTTON: "Turns on/off quantizing for recording. When quantized, recorded triggers will snap to the grid (according to the resolution).",
    AND_TAG_BUTTON: 'Sounds must contain this tag, along with any other red colored tags. Click to unselect this tag.',
    OR_TAG_BUTTON: 'Sounds may contain this tag. Click to unselect this tag.',
    SELECTOR_TAG_BUTTON: 'Click to filter by this tag.',
    SELECTOR_CATEGORY_BUTTON: 'Click to filter by this category of tags.',
    TRACK_PARAMETERS: 'All steps on this track are by default set to these parameters. Changing the parameter for a specific step overrides that default for that step.',
    TRACK_WAVEFORM: 'Drag the markers to set the start/end of the slice. You can also select a new region and click \"Add Slice\" to create additional slices from this sample.',
    SELECTOR_WAVEFORM: 'Click to listen to the sample. Drag to make a selection (which you can then add to the project)',
    DETAIL_VIEW_HAS_SELECTED_SLICE: 'Press a key to map the selected slice to a key. You can also click on the graphical keyboard on this page to map this.',
    GRAPHICAL_KEYBOARD: 'Shows what keys are mapped to what sounds and slices. Click on a mapped key to unmap it. Click on an unmapped key to map it to the selected slice for this track',
    ENVELOPE_TRACK_DROPDOWN: 'Specify which track will trigger this envelope.',
    MODULATOR_CONTROL: "Controls the min and max values that the modulator controls this parameter by",
    LFO_MIN_SLIDER: 'Controls the minimum value that LFO oscillators from at the given rate',
    LFO_MAX_SLIDER: 'Controls the maximum value that LFO oscillators to at the given rate',
    PARAMETERIZER_FACTOR: 'Multiplies the chosen parameter\`s value by this factor, everytime the track triggers',
    PARAMETERIZER_OFFSET: 'Sums the chosen parameter\`s value with this offset, everytime the track triggers.',
    PROBABILITY: 'Controls the probability rate which this MIDI effect will apply. I.E. 100% means it always applies ',
    PARAMETERIZER_DROPDOWN: 'Specifiy the parameter which this effect will apply to.',
    RESAMPLE: 'Resamples this track\'s pattern (including effects), creating a new track with the recorded sample',
    TRANSCRIBE: 'Transcribes the midi notes for this sample, creating a new External Instrument track with the transcribed midi notes (takes a few seconds to run).',
    PLAY_MIX_BUTTON: 'Plays a recorded arrangement (if there is one)',
    RECORD_MIX_BUTTON: 'Record an arrangement, so that all pattern switches, parameter changes are recorded and can be played back.',
    ARRANGEMENT_LOOP_BUTTON: 'Toggles looping for an arrangement, with the start and end points in the arrangement view', 
    AUTOMATION_BUTTON: 'When clicked, and the RECORD button at the bottom is turned on, any automation changes made within a pattern are recorded to that pattern. To delete the automations, hold down the / key',
    AUDITION_BUTTON: 'Audition this sample, replacing the current sample in the selected track with it.',
    CONVOLVER_BUTTON: 'Replace a convolver reverb\'s impulse sample with this sample',
    LAYER_BUTTON: 'Add this sample to the selected track, so that multiple samples can be triggered by one track.',
    ADD_SYNTH_BUTTON: 'Click to add a simple synth to the project',
    ADD_MULTI_SYNTH_BUTTON: 'Click to add a multi-oscillator synth to the project',
    ADD_FM_SYNTH_BUTTON: 'Click to add an FM synth to the project',
    ADD_EXTERNAL_INSTRUMENT_BUTTON: 'Click to add an external instrument to the project. This can control midi devices connected to your computer, including hardware synths',
    ADD_PRESET_BUTTON: 'Click to add this preset to your project',
    LFO_COMPONENT: 'An LFO oscillates between minimum and maximum values, at a constant rate. You can connect parameters to an LFO to modulate its value',
    ENVELOPE_COMPONENT: 'An envelope is triggered any time its connected track has triggered. When triggered, it can control parameter values according to the ASDR (attack, sustain, decay, release) of the envelope.',
    ADD_ALL_SOUNDS_BUTTON: 'Click to select sounds, instruments, presets, and/or sequences to load into the project.',
    ADD_SOUNDS_BUTTON: 'Click to search for and load sounds into your project.',
    ADD_INSTRUMENTS_BUTTON: 'Click to add instruments (e.g. synths) into your project.',
    ADD_PRESETS_BUTTON: 'Click to add saved presets into your project.',
    ADD_SEQUENCES_BUTTON: 'Click to search for and load saved projects.',
    VIEW_DROPDOWN: 'Go to other views, like the mix view',
    BPM_SLIDER: 'Set the BPM (i.e. the tempo) of the project',
    SWING_SLIDER: 'Set the swing of the project.',
    BPM_LOCK: 'Lock/unlock the pattern BPM. This allows different patterns to have different BPMs',
    PUBLIC_SAVE: 'Saves the sequence publicly-- without encryption-- so anyone can see',
    PRIVATE_SAVE: 'Saves the sequence encrypted, so that only you can see (with a password)',
    PARAMETER_VALUE: 'Click to edit the parameter value',
    PRESET_FOLDERS: 'Choose ready-to-go presets to add to your track (by double-clicking the item).',
    GUILDS_SELECTOR: 'Chooses the selected Guild. When selected, only show samples, presets, sequences from that Guild.',
    FREEZE_BUTTON: 'Click to freeze all the patterns for this track. This will free up your CPU.',
    UNFREEZE_BUTTON: 'Click to unfreeze this track, back to its original settings.',
    TRACK_LENGTH_BUTTON: 'Click to choose the length for this track.',
    TRACK_DELETE_BUTTON: 'Click to delete this track from your project.',
    WARP_BUTTON: 'Click to warp this track, syncing it\'s tempo to the project\'s tempo.',
    QUICK_ADD_BUTTON: (obj) => `Click to add a random ${obj} sample to your project.`,
    QUICK_ADD_INSTRUMENT_BUTTON: (obj) => `Click to add a blank ${obj} track to your project.`,
    FILTER_BY_DAY: "Click to filter sounds by adding on this day.",
    FILTER_BY_DAY_TAG: obj => [
        "Click to filter sounds by a tag sampled on this day.",
        obj
    ],
    FILTER_BY_TAG: (tag) => `Click to search for all \"${tag}\" sounds.`,
    PLAYHEAD_DIRECTION_BUTTON: 'Click to select the playhead\'s direction-mode for this track',
    BROWSE_SOUNDS: 'Click to browse through related sounds for this track.',
    ENVELOPE_TOGGLE: (obj) => `Click to toggle Envelope ${obj} to be triggered by this track. `,
    SIDEBAR_SEARCH: "Type to search for samples, effects and presets. Results will appear below that you can click to add.",
    SOUNDS_SEARCH: "Type to search for sounds by tag or title.",
    METRONOME_BUTTON: "Click to turn on/off the metronome.",
    CHOOSE_INSTRUMENT_PRESET : 'Click to load this preset into the currently selected track',
    FILTER_INSTRUMENT_TAG : (tag) => `Click to filter presets by the "${tag}" tag`,
    INSTRUMENT_FX_LOAD : [
        "Toggles whether we should load the effects from the any presets",
        "When toggled, the preset\'s effects will replace the current effects"
    ],
    INSTRUMENT_MODS_LOAD : [
        "Toggles whether we should load the modulators from the any presets",
        "When toggled, the preset\'s modulators will replace the current modulator configuration."
    ],
    OPERATOR_HARMONICITY_MODULATION: obj => `Controls the harmonicity (x-axis) and modulation (y-axis) of operator ${obj}`,
    SYNTH_ENVELOPE: obj => `Controls the attack, decay, sustain, release of ${obj}`,
    SELECTOR_GRID_VIEW:  "Click to view samples by day, in a grid",
    SELECTOR_LIST_VIEW:  "Click to view samples as a list",
    RACK_CONFIGURATION_OPTION: "Choose the routing configuration (i.e. how the effects are connected) for this rack",
    NEW_RACK_CONFIGURATION: [
        "Create a new routing configuration (i.e. how the effects are connected) for this rack",
        "Copies the current routing."
    ],
    RACK_NODE_OUTPUT: 'Drag from here to another effect to connect them.',
    RACK_NODE_INPUT: 'Drag to here from another effect to connect them.',
    RACK_MODULATOR_OUTPUT: 'Drag from here to an effect parameter to modulate that parameter.',
    PADS_DELETE_BUTTON : ["Toggle delete mode", "When in delete mode, hold down track to delete steps"],
    PADS_SLOT_EMPTY : "Drag tracks and samples here to assign to pad",
    PADS_SLOT: "Change volume of track by sliding mouse",
    PADS_MUTES_BUTTON: ["Toggle mute mode", "When in mute mode, clicking pads mutes/unmutes"],
    PADS_WAVEFORM_BUTTON: "Toggle waveform mode",
    PADS_EXPAND_BUTTON: "Shows expanded view for selected track",
    PADS_LENGTH_BUTTON: "Click to change the pattern length of all the tracks.",
};

